module.exports = __webpack_public_path__ + "img/coin.a0af6e45.svg";